import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredNumberColumn,
    FilteredTextColumn,
    WarningSignColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new WarningSignColumn(
          'Alert', 'onHand', true,
          {
            compareLeft: 'min',
            compareRight: 'max',
          },
        ).withWidth(55),
        new FilteredTextColumn('Operator', 'operatorCode'),
        new FilteredTextColumn('IMPC', 'impcCode'),
        new FilteredNumberColumn('Min', 'min'),
        new FilteredNumberColumn('Max', 'max'),
        new FilteredNumberColumn('On Hand', 'onHand'),
      ],
    },
  ];
};
